module.exports = __webpack_public_path__ + "img/questionBank.f1644fdb.svg";